module.exports = __webpack_public_path__ + "img/cz.eb187438.svg";